import api from "../_api";

const actions = {
    updateBookingCartRate: ({ commit, dispatch }, payload) => {
        commit("UPDATE_BOOKING_CART_RATE", payload);
    },
    updateBookingCart: ({ commit, dispatch }, payload) => {
        commit("UPDATE_BOOKING_CART", payload);
    },
    payBooking: ({ commit, dispatch, state }, payload) => {
        let data = {
            cardData: payload.cardPayload,
            couponCart: payload.couponCart,
            bookingCart: state.bookingCart,
            donationCart: payload.donationCart,
        };

        return new Promise((resolve, reject) => {
            commit("PAYMENT_LOADING");

            api.paybooking(data)
                .then(resp => {
                    commit("PAYMENT_SUCCESS", resp.data);
                    dispatch("user/userRequest", null, { root: true });
                    resolve(resp.data.data.o_id);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("PAYMENT_ERROR", errors);
                    reject(err.response);
                });
        });
    },
    clearPaymentErrors: ({ commit }) => {
        commit("CLEAR_PAYMENT_ERRORS");
    },
    mybookingsRequest: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit("BOOKING_LOADING");

            api.mybookings()
                .then(resp => {
                    commit("MYBOOKING_SUCCESS", resp.data.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("BOOKING_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
};

export default actions;
